'use strict';

var jsxRuntime = require('react/jsx-runtime');

const LargePersonSmile = ({ disabled = false })=>{
    if (disabled) {
        return jsxRuntime.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: "60",
            height: "60",
            viewBox: "0 0 60 60",
            fill: "none",
            "data-testid": "design-system-productIcon-icon-person_smile--disabled",
            children: [
                jsxRuntime.jsx("path", {
                    d: "M12 44C12 38.4772 16.4772 34 22 34H38C43.5228 34 48 38.4772 48 44V50H12V44Z",
                    fill: "#E0E0E0",
                    stroke: "#9E9E9E",
                    strokeWidth: "1.4",
                    strokeLinejoin: "round"
                }),
                jsxRuntime.jsx("path", {
                    d: "M30 30C35.5228 30 40 25.5228 40 20C40 14.4772 35.5228 10 30 10C24.4772 10 20 14.4772 20 20C20 25.5228 24.4772 30 30 30Z",
                    fill: "white",
                    stroke: "#9E9E9E",
                    strokeWidth: "1.4",
                    strokeLinecap: "round",
                    strokeLinejoin: "round"
                }),
                jsxRuntime.jsx("path", {
                    d: "M33 18.5C33.5523 18.5 34 18.0523 34 17.5C34 16.9477 33.5523 16.5 33 16.5C32.4477 16.5 32 16.9477 32 17.5C32 18.0523 32.4477 18.5 33 18.5Z",
                    fill: "#9E9E9E"
                }),
                jsxRuntime.jsx("path", {
                    d: "M27 18.5C27.5523 18.5 28 18.0523 28 17.5C28 16.9477 27.5523 16.5 27 16.5C26.4477 16.5 26 16.9477 26 17.5C26 18.0523 26.4477 18.5 27 18.5Z",
                    fill: "#9E9E9E"
                }),
                jsxRuntime.jsx("path", {
                    d: "M33 22.7056C32.7246 23.8338 31.4783 24.7056 30 24.7056C28.5362 24.7056 27.2899 23.8594 27 22.7312",
                    stroke: "#9E9E9E",
                    strokeWidth: "1.4",
                    strokeLinecap: "round",
                    strokeLinejoin: "round"
                })
            ]
        });
    }
    return jsxRuntime.jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "60",
        height: "60",
        viewBox: "0 0 60 60",
        fill: "none",
        "data-testid": "design-system-productIcon-icon-person_smile",
        className: "text-primary",
        children: [
            jsxRuntime.jsx("path", {
                d: "M12 44C12 38.4772 16.4772 34 22 34H38C43.5228 34 48 38.4772 48 44V50H12V44Z",
                fill: "currentColor",
                stroke: "#212121",
                strokeWidth: "1.4",
                strokeLinejoin: "round"
            }),
            jsxRuntime.jsx("path", {
                d: "M30 30C35.5228 30 40 25.5228 40 20C40 14.4772 35.5228 10 30 10C24.4772 10 20 14.4772 20 20C20 25.5228 24.4772 30 30 30Z",
                fill: "white",
                stroke: "#212121",
                strokeWidth: "1.4",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            jsxRuntime.jsx("path", {
                d: "M33 18.5C33.5523 18.5 34 18.0523 34 17.5C34 16.9477 33.5523 16.5 33 16.5C32.4477 16.5 32 16.9477 32 17.5C32 18.0523 32.4477 18.5 33 18.5Z",
                fill: "#212121"
            }),
            jsxRuntime.jsx("path", {
                d: "M27 18.5C27.5523 18.5 28 18.0523 28 17.5C28 16.9477 27.5523 16.5 27 16.5C26.4477 16.5 26 16.9477 26 17.5C26 18.0523 26.4477 18.5 27 18.5Z",
                fill: "#212121"
            }),
            jsxRuntime.jsx("path", {
                d: "M33 22.7056C32.7246 23.8338 31.4783 24.7056 30 24.7056C28.5362 24.7056 27.2899 23.8594 27 22.7312",
                stroke: "#212121",
                strokeWidth: "1.4",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
};
const MediumPersonSmile = ()=>{
    return jsxRuntime.jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "40",
        height: "40",
        viewBox: "0 0 40 40",
        fill: "none",
        className: "text-primary",
        children: [
            jsxRuntime.jsx("path", {
                d: "M6 33C6 27.4772 10.4772 23 16 23H24C29.5228 23 34 27.4772 34 33V36H6V33Z",
                fill: "currentColor",
                stroke: "#212121",
                strokeWidth: "1.4"
            }),
            jsxRuntime.jsx("path", {
                d: "M20 20C24.4183 20 28 16.4183 28 12C28 7.58172 24.4183 4 20 4C15.5817 4 12 7.58172 12 12C12 16.4183 15.5817 20 20 20Z",
                fill: "white",
                stroke: "#212121",
                strokeWidth: "1.4",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            jsxRuntime.jsx("path", {
                d: "M22.4001 10.8C22.8419 10.8 23.2001 10.4418 23.2001 9.99995C23.2001 9.55812 22.8419 9.19995 22.4001 9.19995C21.9583 9.19995 21.6001 9.55812 21.6001 9.99995C21.6001 10.4418 21.9583 10.8 22.4001 10.8Z",
                fill: "#212121"
            }),
            jsxRuntime.jsx("path", {
                d: "M17.5998 10.8C18.0416 10.8 18.3998 10.4418 18.3998 9.99995C18.3998 9.55812 18.0416 9.19995 17.5998 9.19995C17.158 9.19995 16.7998 9.55812 16.7998 9.99995C16.7998 10.4418 17.158 10.8 17.5998 10.8Z",
                fill: "#212121"
            }),
            jsxRuntime.jsx("path", {
                d: "M22.4001 14.1646C22.1798 15.0671 21.1827 15.7646 20.0001 15.7646C18.8291 15.7646 17.832 15.0876 17.6001 14.1851",
                stroke: "#212121",
                strokeWidth: "1.4",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
};
const PersonSmile = ({ size, disabled = false })=>{
    if (size === 'medium') {
        return jsxRuntime.jsx(MediumPersonSmile, {});
    }
    return jsxRuntime.jsx(LargePersonSmile, {
        disabled: disabled
    });
};

module.exports = PersonSmile;
